import { supabase } from './supabase';

export interface Filial {
  id?: string;
  nome: string;
  cidade: string;
  estado: string;
  endereco?: string;
  telefone?: string;
  status: 'ativo' | 'inativo';
  criado_em?: string;
  atualizado_em?: string;
}

class FiliaisService {
  async buscarTodas(): Promise<Filial[]> {
    const { data, error } = await supabase
      .from('filiais')
      .select('*')
      .order('nome');

    if (error) throw error;
    return data || [];
  }

  async buscarPorId(id: string): Promise<Filial | null> {
    const { data, error } = await supabase
      .from('filiais')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data;
  }

  async criar(filial: Filial): Promise<Filial> {
    const { data, error } = await supabase
      .from('filiais')
      .insert([{
        ...filial,
        criado_em: new Date().toISOString(),
        atualizado_em: new Date().toISOString()
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  }

  async atualizar(id: string, filial: Partial<Filial>): Promise<Filial> {
    const { data, error } = await supabase
      .from('filiais')
      .update({
        ...filial,
        atualizado_em: new Date().toISOString()
      })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  }

  async deletar(id: string): Promise<void> {
    const { error } = await supabase
      .from('filiais')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
}

export default new FiliaisService();
